import { Button } from "@components/ui/button"
import {
  AccountOfferFunnelProvider,
  useAccountOfferFunnel,
} from "@components/AccountNew/OfferFunnel/utils/useAccountOfferFunnel"
import { ChooseOffer } from "@components/AccountNew/OfferFunnel/FunnelSteps/ChooseOffer"
import { Verification } from "@components/AccountNew/OfferFunnel/FunnelSteps/Verification"
import { Confirmation } from "@components/AccountNew/OfferFunnel/FunnelSteps/Confirmation"
import { OfferDetail } from "@components/AccountNew/OfferFunnel/FunnelSteps/OfferDetail"
import { CancelMember } from "@components/AccountNew/OfferFunnel/FunnelSteps/CancelMember"

const OffersInner = () => {
  const { eligibleOfferType, step, setStep } = useAccountOfferFunnel()

  return (
    <>
      {eligibleOfferType && (
        <div className="tw:bordered-container">
          {step === "initial" && (
            <Button variant="default" onClick={() => setStep("chooseOffer")}>
              View {eligibleOfferType} Offers
            </Button>
          )}

          {step === "chooseOffer" && <ChooseOffer />}

          {step === "offerDetail" && <OfferDetail />}

          {step === "verification" && <Verification />}

          {step === "cancelMember" && <CancelMember />}

          {step === "confirmation" && <Confirmation />}
        </div>
      )}
    </>
  )
}

export const OffersFunnel = ({ account_id }: { account_id: string }) => (
  <AccountOfferFunnelProvider account_id={account_id}>
    <OffersInner />
  </AccountOfferFunnelProvider>
)
